module.exports = __webpack_public_path__ + "assets/3-best-denver-sales-recruiters.1718bd35.png";